import Typography from "@mui/material/Typography";
import { Link } from "react-router";

import {
  TriggerTargetType,
  type TriggerDispatchRecord,
} from "@/shared/domain/triggers";

/**
 * What a dispatched target produced, linked where a page exists:
 * an invocation, an agent thread, or (plain text) a Slack message timestamp.
 */
export function DispatchResultLink({
  dispatch,
}: {
  dispatch: TriggerDispatchRecord;
}) {
  if (!dispatch.result_ref) {
    return (
      <Typography variant="body2" color="text.secondary">
        —
      </Typography>
    );
  }

  switch (dispatch.target_type) {
    case TriggerTargetType.InvokeAction:
      return (
        <Link to={`/invocations/${dispatch.result_ref}`}>
          {dispatch.result_ref}
        </Link>
      );
    case TriggerTargetType.StartAgent:
      return (
        <Link to={`/agents/threads/${dispatch.result_ref}`}>
          {dispatch.result_ref}
        </Link>
      );
    default:
      return <Typography variant="body2">{dispatch.result_ref}</Typography>;
  }
}
